import React from 'react';
import PropTypes from 'prop-types';

import { Divider } from '@mui/material';
import MedicalContentTreeItem, { useMedicalContentTreeItem } from '../_common/MedicalContentTreeItem';
import MedicationPane from './MedicationPane';
import BasicActionListTreeItem from '../_common/BasicActionListTreeItem';

export default function MedicationTreeItem(props) {
  const {
    id,
    label,
    ptUseActionListId,
    ptRequestActionListId,
    setFormPane,
    refreshParent,
    setTreeManagementServices,
    onDeleteWarningMessage,
    onDeleteConfirmed,
  } = props;

  const {
    MCTreeItemLabel,
    MCTreeItemChildNodes,
    setMCTreeItemChildNodes,
    updateLabel,
  } = useMedicalContentTreeItem(label);

  const fetchChildNodes = async () => {
    setMCTreeItemChildNodes([
      <BasicActionListTreeItem
        key={`Use_${id}`}
        actionListId={ptUseActionListId}
        setFormPane={setFormPane}
        setTreeManagementServices={setTreeManagementServices}
        label="Whenever added to current medication list (Medication-specific questions only)"
      />,
      <BasicActionListTreeItem
        key={`Request_${id}`}
        actionListId={ptRequestActionListId}
        setFormPane={setFormPane}
        setTreeManagementServices={setTreeManagementServices}
        label="Whenever requested - e.g. refills (Patient-level questions only)"
      />,
    ]);
  };

  const onSelect = () => {
    setFormPane(
      <>
        <MedicationPane
          medicationId={id}
          updateCallback={updateLabel}
          refreshParent={refreshParent}
          label={MCTreeItemLabel}
        />
        <Divider />
      </>,
    );
    setTreeManagementServices({
      onDeleteWarningMessage,
      deleteService: onDeleteConfirmed,
      onSuccess: refreshParent,
    });
  };

  return (
    <MedicalContentTreeItem
      id={id}
      MCTreeItemLabel={MCTreeItemLabel}
      MCTreeItemChildNodes={MCTreeItemChildNodes}
      fetchChildNodes={fetchChildNodes}
      onSelect={onSelect}
    />
  );
}

MedicationTreeItem.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  ptUseActionListId: PropTypes.number.isRequired,
  ptRequestActionListId: PropTypes.number.isRequired,
  setFormPane: PropTypes.func.isRequired,
  refreshParent: PropTypes.func.isRequired,
  setTreeManagementServices: PropTypes.func.isRequired,
  onDeleteWarningMessage: PropTypes.string.isRequired,
  onDeleteConfirmed: PropTypes.func.isRequired,
};
